// @flow
import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';

import type {Node} from 'react';

type Props = {
    listing: {
        sleeps: number,
        bedrooms: number,
        spaces: {
            spacesSummary: {
                area?: {areaValue?: number},
                bedCountDisplay?: string
            }
        }
    }
};

const RoomsBedsDetails = ({listing}: Props) => {
    const {sleeps, bedrooms, spaces} = listing;
    const {spacesSummary} = spaces || {};
    const {bedCountDisplay} = spacesSummary || {};
    const hasBedroomsOrSleepsOrBeds = bedrooms || sleeps || bedCountDisplay;

    return (
        <Fragment>
            {!!hasBedroomsOrSleepsOrBeds && (
                <div className="HitInfo__room-beds-details">
                    {!!sleeps && (
                        <span>
                            <FormattedMessage
                                id="sleepsAbbreviation"
                                description="sleeps label"
                                defaultMessage="{value, plural, zero {Sleeps {value}} one {Sleeps {value}} few {Sleeps {value}} many {Sleeps {value}} other {Sleeps {value}}}"
                                values={{
                                    value: sleeps
                                }}
                            >
                                {(txt: Node): Node => txt}
                            </FormattedMessage>
                        </span>
                    )}
                    {!!bedrooms && (
                        <span>
                            <FormattedMessage
                                id="sectionTitleBedrooms"
                                description="bedrooms label"
                                defaultMessage="bedrooms"
                                values={{
                                    bedrooms
                                }}
                            >
                                {(txt: Node): Node => txt}
                            </FormattedMessage>
                        </span>
                    )}
                    {!!bedCountDisplay && <span>{bedCountDisplay}</span>}
                </div>
            )}
        </Fragment>
    );
};

export default RoomsBedsDetails;
